var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log-list"},[_c('list',{attrs:{"fs":_vm.logFields,"api":"logs","showAction":false,"showSearch":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }